import React, { useMemo } from 'react'
import AdminManagement from './index'
import { GenericForm } from './GenericForm'
import { ShieldCheck } from 'lucide-react'

const AdminsManagement = () => {
  const columns = useMemo(() => [
    {
      key: 'nombre',
      label: 'Nombre',
      render: (item) => `${item.nombre} ${item.apellido} `
    },
    { key: 'email', label: 'Email' },
    { key: 'dni', label: 'DNI' },
    { key: 'username', label: 'Usuario' },
    {
      key: 'createdAt',
      label: 'Fecha de creación',
      render: (item) => item.createdAt ? new Date(item.createdAt).toLocaleDateString() : ' - '
    }
  ], [])

  const FormComponent = useMemo(() => {
    return (props) => {
      const formFields = [
        { key: 'dni', label: 'DNI', type: 'number', required: true },
        {
          key: 'genero',
          label: 'Género',
          type: 'select',
          required: true,
          options: [
            { value: 'Masculino', label: 'Masculino' },
            { value: 'Femenino', label: 'Femenino' }
          ]
        },
        { key: 'nombre', label: 'Nombre', required: true },
        { key: 'apellido', label: 'Apellido', required: true },
        { key: 'username', label: 'Usuario', required: true },
        { key: 'email', label: 'Correo electrónico', type: 'email', required: true },
        { key: 'clave', label: 'Contraseña', type: 'password', required: !props.initialData },
        {
          key: 'confirmarClave',
          label: 'Repetir contraseña',
          type: 'password',
          required: !props.initialData,
          matchesField: 'clave',
          errorMessage: 'Las contraseñas no coinciden.',
          clientOnly: true
        }
      ]

      const fields = formFields.filter(f => !props.initialData || !['clave', 'confirmarClave'].includes(f.key))

      const handleSubmit = (data) => {
        const finalData = { ...data, rol: 'admin' }
        props.onSubmit(finalData)
      }

      return <GenericForm {...props} fields={fields} title='Administrador' onSubmit={handleSubmit} />
    }
  }, [])

  return (
    <AdminManagement
      entityType='Administradores'
      headerSubtitle='Desde acá podés agregar, modificar o eliminar administradores del sistema. Cuidado: estos administradores tienen los mismos privilegios de acceso que vos.'
      HeaderIcon={ShieldCheck}
      columns={columns}
      apiEndpoint='usuarios/admins'
      FormComponent={FormComponent}
      gridTemplateColumns='1.5fr 1.5fr 1fr 1fr 1.2fr 0.8fr'
      singularEntityName='Administrador'
    />
  )
}

export default AdminsManagement
